export default __webpack_public_path__ + "static/media/background-header-puntoian.851d3dd7.jpg";